import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes } from "react-router-dom";
import { DynamicInvoiceRoutes } from "src/domains/dynamic-invoice";
import { HomePage } from "./domains/application";
export const ApplicationRoutes = () => (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(HomePage, {}) }), _jsx(Route, { path: "dynamic-invoice/*", element: _jsx(DynamicInvoiceRoutes, {}) })] }));
